module.exports = __webpack_public_path__ + "img/index_pic2.f7420697.png";